import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { PENDING, IDLE, EDIT } from "const"
import {
    QidCompanyDocument,
    MtDriveFile,
} from "server/models"
import { deepCopy, hasAccess, StateType } from "client/utils"
import {
    PRM_QID_COMPANY,
    StoreType,
    QidCompanyDocumentList,
    LoadAllQidCompanyDocuments,
    AddQidCompanyDocument,
    DeleteQidCompanyDocument,
    setQidCompanyDocumentList,
    setQidCompanyDocumentReloadList,
    addModal,
} from "client/store"
import {
    Container,
    PageContent,
    Loader,
    Button,
    Table,
    DeleteRow,
} from "client/components"

import Drive from "client/pages/drive"
import Columns from "./columns"

const Documents = () => {
    const company = useSelector((state: StoreType) => state.qidCompany.companyView)

    const documentList = useSelector((state: StoreType) => state.qidCompanyDocument.documentList)
    const documentIds = useSelector((state: StoreType) => state.qidCompanyDocument.documentIds)
    const reloadList = useSelector((state: StoreType) => state.qidCompanyDocument.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        if (!company || !company.id) return

        setLoadState(PENDING)
        LoadAllQidCompanyDocuments(company.id)
        .then((res) => {
            dispatch(setQidCompanyDocumentList(res.documentList, res.documentIds))
            setLoadState(IDLE)
        })
    }, [company, reloadList])

    const onDelete: DeleteRow = (document: QidCompanyDocument, callback) => {
        DeleteQidCompanyDocument(document.companyId, document.fileId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const documentListCopy: QidCompanyDocumentList = documentList ? deepCopy(documentList) : {}
                delete documentListCopy[document.fileId]
                const newDocumentIds = documentIds.filter((id) => id !== document.fileId)

                dispatch(setQidCompanyDocumentList(documentListCopy, newDocumentIds))
            })
        })
    }

    const onAdd = (file: MtDriveFile) => {
        setLoadState(PENDING)
        AddQidCompanyDocument(company.id, file.id).then(() => {
            dispatch(setQidCompanyDocumentReloadList(false))
            setTimeout(() => {
                dispatch(setQidCompanyDocumentReloadList(true))
            }, 0)
        })
    }

    const companyEditAccess = hasAccess(PRM_QID_COMPANY, EDIT)
    const columns = Columns(companyEditAccess)

    return (
        <Container>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Table
                    columns={columns}
                    dataList={documentList}
                    dataIds={documentIds}
                    rowSize="fit"
                    onDelete={onDelete}
                    bottomContent={companyEditAccess && (
                        <Button
                            variant="success"
                            onClick={() => {
                                dispatch(addModal({
                                    key: "drive",
                                    content: <Drive onSelectFile={onAdd} />,
                                }))
                            }}
                        >
                            {lang.add}
                        </Button>
                    )}
                />
            </PageContent>
        </Container>
    )
}
export default Documents
